import { adminHeaders } from "./auth";
import { marketplaceHeaders } from "./marketplaceAuth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function fetchCars(filters = {}, page = 1, pageSize = 12, signal) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (Array.isArray(value)) {
        value.forEach((item) => params.append(key, item));
      } else {
        params.append(key, value);
      }
    }
  });

  if (page) params.set("page", String(page));
  if (pageSize) params.set("limit", String(pageSize));

  const response = await fetch(`${API_URL}/cars?${params.toString()}`, {
    signal,
    headers: marketplaceHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Error fetching cars: ${response.statusText}`);
  }

  const data = await response.json();

  if (Array.isArray(data)) {
    return {
      cars: data,
      totalPages: Math.max(1, Math.ceil(data.length / pageSize || 1)),
    };
  }

  return data ?? { cars: [], totalPages: 1 };
}

export async function fetchSellerCars() {
  const result = await fetchCars({ sellerOnly: "true", type: "vehicle" }, 1, 100);
  return result.cars || [];
}

export async function fetchCar(id) {
  const response = await fetch(`${API_URL}/cars/${id}`);

  if (!response.ok) {
    throw new Error(`Error fetching car: ${response.statusText}`);
  }

  return response.json();
}

export async function recordCarView(id) {
  const response = await fetch(`${API_URL}/cars/${id}/view`, { method: "POST" });
  if (!response.ok) throw new Error("Unable to record vehicle view.");
  return response.json();
}

export async function createCar(car) {
    const response  = await fetch(`${API_URL}/cars`, {
        method: "POST",
        headers: {
            ...adminHeaders(),
            ...marketplaceHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(car),

    });

    if (!response.ok) {
        throw new Error(`Error creating car: ${response.statusText}`);
    }

    return response.json();
}

export async function updateCar(id, car) {
    const response  = await fetch(`${API_URL}/cars/${id}`, {
        method: "PUT", 
        headers: {
            ...adminHeaders(),
            ...marketplaceHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(car),
    });
    
    if (!response.ok) {
        throw new Error(`Error updating car: ${response.statusText}`);
    }
    return response.json();
}


export async function deleteCar(id) {
    const response = await fetch(`${API_URL}/cars/${id}`, {
        method: "DELETE",
        headers: { ...adminHeaders(), ...marketplaceHeaders() },
    });

    if (!response.ok) {
        throw new Error(`Error deleting car: ${response.statusText}`);
    }

    return true;
}